export default {
  title: 'Ruokavalio-ominaisuudet',
};
